// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KZIGJQTFtC_dqdFPVc62 {
  text-decoration: none;
  font-weight: 500;
  border-radius: 5px;
  padding: 8px 36px;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .3s;
  line-height: 20px;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
}

.iduLTeo4GkzcqyKIJp5e.v7mNfBkk2ikspcLRuFi1 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  color: white;
}

.iduLTeo4GkzcqyKIJp5e.v7mNfBkk2ikspcLRuFi1:hover {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
}

.iduLTeo4GkzcqyKIJp5e.v7mNfBkk2ikspcLRuFi1:focus {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-focus"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
}

.oGzSZzrEq9JWUHzBpqIg.v7mNfBkk2ikspcLRuFi1 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  color: white;
}

.oGzSZzrEq9JWUHzBpqIg.v7mNfBkk2ikspcLRuFi1:hover {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
  color: white;
}

.oGzSZzrEq9JWUHzBpqIg.v7mNfBkk2ikspcLRuFi1:focus {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]};
  color: white;
}

.n3nNaan3wbnHxdWG67rf.v7mNfBkk2ikspcLRuFi1 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  color: white;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.4;
}

.n3nNaan3wbnHxdWG67rf.YgtUFo7spBnxS6YJm1Ns {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
}

.iduLTeo4GkzcqyKIJp5e.YgtUFo7spBnxS6YJm1Ns {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  background: none;
}

.iduLTeo4GkzcqyKIJp5e.YgtUFo7spBnxS6YJm1Ns:hover {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-red-bg"]};
}

.iduLTeo4GkzcqyKIJp5e.YgtUFo7spBnxS6YJm1Ns:focus {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-focus"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-red-bg"]};
}

.oGzSZzrEq9JWUHzBpqIg.YgtUFo7spBnxS6YJm1Ns {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  background: none;
}

.oGzSZzrEq9JWUHzBpqIg.YgtUFo7spBnxS6YJm1Ns:hover {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
}

.oGzSZzrEq9JWUHzBpqIg.YgtUFo7spBnxS6YJm1Ns:focus {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
}

.xzcc74I0fQVpoalobTaP {
  border: none;
  background: none;
}

.iduLTeo4GkzcqyKIJp5e.xzcc74I0fQVpoalobTaP {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  padding: 0;
}

.iduLTeo4GkzcqyKIJp5e.xzcc74I0fQVpoalobTaP:hover {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
}

.iduLTeo4GkzcqyKIJp5e.xzcc74I0fQVpoalobTaP:focus {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-focus"]};
}

.oGzSZzrEq9JWUHzBpqIg.xzcc74I0fQVpoalobTaP {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  padding: 0;
}

.oGzSZzrEq9JWUHzBpqIg.xzcc74I0fQVpoalobTaP:hover {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
}

.oGzSZzrEq9JWUHzBpqIg.xzcc74I0fQVpoalobTaP:focus {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]};
}

.ynNmfAEmx4fsuuwwcvGo.v7mNfBkk2ikspcLRuFi1 {
  background: #F0F1FB;
  border: 1px solid #D2D7F4;
  border-radius: 5px;
  font-weight: 400;
  transition: 0.3s;
}

.ynNmfAEmx4fsuuwwcvGo.v7mNfBkk2ikspcLRuFi1:hover,
.ynNmfAEmx4fsuuwwcvGo.v7mNfBkk2ikspcLRuFi1:focus {
  background: #D2D7F4;
  border-color: #a1a4c4;
}

.n3nNaan3wbnHxdWG67rf.xzcc74I0fQVpoalobTaP {
  color: #C0BFCF;
}

.S5MNjqwJvyoiFcNHgstn {
  margin-right: 8px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.S5MNjqwJvyoiFcNHgstn svg {
  line-height: 20px;
  height: 20px;
}

.ynQdFwwmEIs_XP_I_UEL {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  min-width: 88px;
  font-size: 16px;
}

.iiasxSplH_RCwwCPjDqy {
  line-height: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  min-width: 112px;
  font-size: 1rem;
}

.tNt5qUVCnztS9OiE9bRu {
  height: 48px;
  min-width: 112px;
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Button/Button.module.css"],"names":[],"mappings":"AAGA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,8DAAwC;AAC1C;;AAEA;EACE,8DAAsC;EACtC,0DAAkC;EAClC,YAAY;AACd;;AAEA;EACE,8DAA4C;EAC5C,0DAAwC;AAC1C;;AAEA;EACE,8DAA4C;EAC5C,0DAAwC;AAC1C;;AAEA;EACE,8DAAwC;EACxC,0DAAoC;EACpC,YAAY;AACd;;AAEA;EACE,8DAA8C;EAC9C,0DAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,8DAA8C;EAC9C,0DAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,8DAAwC;EACxC,0DAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mDAAiB;EACjB,8DAA4B;AAC9B;;AAEA;EACE,8DAAsC;EACtC,mDAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,8DAA4C;EAC5C,mDAAiC;EACjC,8DAA8B;AAChC;;AAEA;EACE,8DAA4C;EAC5C,mDAA2B;EAC3B,8DAA8B;AAChC;;AAEA;EACE,8DAAwC;EACxC,mDAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8DAA8C;EAC9C,mDAAmC;EACnC,8DAAiC;AACnC;;AAEA;EACE,8DAA8C;EAC9C,mDAA6B;EAC7B,8DAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mDAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,mDAAiC;AACnC;;AAEA;EACE,mDAAiC;AACnC;;AAEA;EACE,mDAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,mDAAmC;AACrC;;AAEA;EACE,mDAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["@value colors: \"../style/colors.css\";\n@value color-gray, color-red-bg, color-purple-bg, color-button-primary, color-button-primary-hover, color-button-primary-focus, color-button-secondary, color-button-secondary-hover, color-button-secondary-focus, color-purple-bg, color-success from colors;\n\n.button {\n  text-decoration: none;\n  font-weight: 500;\n  border-radius: 5px;\n  padding: 8px 36px;\n  cursor: pointer;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: .3s;\n  line-height: 20px;\n  border: 1px solid color-button-secondary;\n}\n\n.primary.fill {\n  background-color: color-button-primary;\n  border-color: color-button-primary;\n  color: white;\n}\n\n.primary.fill:hover {\n  background-color: color-button-primary-hover;\n  border-color: color-button-primary-hover;\n}\n\n.primary.fill:focus {\n  background-color: color-button-primary-focus;\n  border-color: color-button-primary-hover;\n}\n\n.secondary.fill {\n  background-color: color-button-secondary;\n  border-color: color-button-secondary;\n  color: white;\n}\n\n.secondary.fill:hover {\n  background-color: color-button-secondary-hover;\n  border-color: color-button-secondary-hover;\n  color: white;\n}\n\n.secondary.fill:focus {\n  background-color: color-button-secondary-focus;\n  border-color: color-button-secondary-focus;\n  color: white;\n}\n\n.disabled.fill {\n  background-color: color-button-secondary;\n  border-color: color-button-secondary;\n  color: white;\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.4;\n}\n\n.disabled.outline {\n  color: color-gray;\n  border: 1px solid color-gray;\n}\n\n.primary.outline {\n  border: 1px solid color-button-primary;\n  color: color-button-primary;\n  background: none;\n}\n\n.primary.outline:hover {\n  border: 1px solid color-button-primary-hover;\n  color: color-button-primary-hover;\n  background-color: color-red-bg;\n}\n\n.primary.outline:focus {\n  border: 1px solid color-button-primary-focus;\n  color: color-button-primary;\n  background-color: color-red-bg;\n}\n\n.secondary.outline {\n  border: 1px solid color-button-secondary;\n  color: color-button-secondary;\n  background: none;\n}\n\n.secondary.outline:hover {\n  border: 1px solid color-button-secondary-hover;\n  color: color-button-secondary-hover;\n  background-color: color-purple-bg;\n}\n\n.secondary.outline:focus {\n  border: 1px solid color-button-secondary-focus;\n  color: color-button-secondary;\n  background-color: color-purple-bg;\n}\n\n.ghost {\n  border: none;\n  background: none;\n}\n\n.primary.ghost {\n  color: color-button-primary;\n  padding: 0;\n}\n\n.primary.ghost:hover {\n  color: color-button-primary-hover;\n}\n\n.primary.ghost:focus {\n  color: color-button-primary-focus;\n}\n\n.secondary.ghost {\n  color: color-button-secondary;\n  padding: 0;\n}\n\n.secondary.ghost:hover {\n  color: color-button-secondary-hover;\n}\n\n.secondary.ghost:focus {\n  color: color-button-secondary-focus;\n}\n\n.discrete.fill {\n  background: #F0F1FB;\n  border: 1px solid #D2D7F4;\n  border-radius: 5px;\n  font-weight: 400;\n  transition: 0.3s;\n}\n\n.discrete.fill:hover,\n.discrete.fill:focus {\n  background: #D2D7F4;\n  border-color: #a1a4c4;\n}\n\n.disabled.ghost {\n  color: #C0BFCF;\n}\n\n.icon {\n  margin-right: 8px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon svg {\n  line-height: 20px;\n  height: 20px;\n}\n\n.small {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  min-width: 88px;\n  font-size: 16px;\n}\n\n.medium {\n  line-height: 1.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  min-width: 112px;\n  font-size: 1rem;\n}\n\n.large {\n  height: 48px;\n  min-width: 112px;\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../style/colors.css"`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"color-red-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-red-bg"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-button-primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]}`,
	"color-button-primary-hover": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]}`,
	"color-button-primary-focus": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-focus"]}`,
	"color-button-secondary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]}`,
	"color-button-secondary-hover": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]}`,
	"color-button-secondary-focus": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]}`,
	"color-success": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success"]}`,
	"button": `KZIGJQTFtC_dqdFPVc62`,
	"primary": `iduLTeo4GkzcqyKIJp5e`,
	"fill": `v7mNfBkk2ikspcLRuFi1`,
	"secondary": `oGzSZzrEq9JWUHzBpqIg`,
	"disabled": `n3nNaan3wbnHxdWG67rf`,
	"outline": `YgtUFo7spBnxS6YJm1Ns`,
	"ghost": `xzcc74I0fQVpoalobTaP`,
	"discrete": `ynNmfAEmx4fsuuwwcvGo`,
	"icon": `S5MNjqwJvyoiFcNHgstn`,
	"small": `ynQdFwwmEIs_XP_I_UEL`,
	"medium": `iiasxSplH_RCwwCPjDqy`,
	"large": `tNt5qUVCnztS9OiE9bRu`
};
export default ___CSS_LOADER_EXPORT___;
